import { encodedUrls } from "../../config/experimentation/data";

import { GetStaticPropsData } from "./createMiddlewareConfig";

// this is the prefix we use to encode our urls
export const BREX_PREFIX = "br-exp/";
export const encode = ({
  uniqueId,
  pageType,
  inputtedUrl,
}: {
  /**
   * generated uuid function, this is used to decode the url
   */
  uniqueId: string;
  pageType: string;
  inputtedUrl?: string;
}) => {
  if (pageType === "staticUrl") return `/${inputtedUrl}`;
  return `/${BREX_PREFIX + uniqueId}`;
};

export const decode = (
  url: string,
  groupedByUniqueId: any = encodedUrls,
):
  | GetStaticPropsData
  | {
      url: string;
      isExperiment: false;
      experimentType: undefined;
      variation: undefined;
    } => {
  const nonExperimentUrl = {
    url,
    isExperiment: false as const,
    experimentType: undefined,
    variation: undefined,
  };
  if (!url.includes(BREX_PREFIX)) return nonExperimentUrl;
  const uniqueId = url.split(BREX_PREFIX)[1];

  const urlOptions = groupedByUniqueId[uniqueId];

  if (!urlOptions) return nonExperimentUrl;
  return { ...urlOptions, isExperiment: true };
};
